export default "__VITE_ASSET__1fc347bc__"